import D2C_ProviderLog from './Log'

class D2C_ProviderGelf extends D2C_ProviderLog {
  static objectType = 'providerType'
  static active = true
  static order = 61
  static providerType = 'gelf'
  static providerTitle = 'Graylog Extended Format'
  static fields = {
    ...D2C_ProviderLog.fields,
    address: {
      default: '',
      label: 'Address',
      path: 'options.gelfAddress',
      required: true,
      validate(value) {
        return value ? null : 'Must be set'
      },
      creating: {},
    },
    env: {
      default: 'container_hostname',
      label: 'Env',
      path: 'options.env',
      required: true,
      validate(value) {
        return value ? null : 'Must be set'
      },
      creating: {},
    },
    tag: {
      default: '',
      label: 'Tag',
      path: 'options.tag',
      required: false,
      validate() {
        return null
      },
      creating: {},
    },
    compressionType: {
      default: 'none',
      enum: [
        {value: 'none', text: 'none'},
        {value: 'gzip', text: 'gzip'},
        {value: 'zlib', text: 'zlib'},
      ],
      label: 'Compression Type',
      path: 'options.gelfCompressionType',
      required: false,
      width: 6,
      validate() {
        return null
      },
      prepare(value, entity) {
        if (entity.options.gelfAddress.includes('udp://')) {
          return value
        }
        return undefined
      },
      creating: {},
    },
    compressionLevel: {
      default: 1,
      enum: [
        {value: 0, text: '0'},
        {value: 1, text: '1'},
        {value: 2, text: '2'},
        {value: 3, text: '3'},
        {value: 4, text: '4'},
        {value: 5, text: '5'},
        {value: 6, text: '6'},
        {value: 7, text: '7'},
        {value: 8, text: '8'},
        {value: 9, text: '9'},
      ],
      label: 'Compression Level',
      path: 'options.gelfCompressionLevel',
      required: false,
      width: 10,
      validate() {
        return null
      },
      prepare(value, entity) {
        if (entity.options.gelfAddress.includes('udp://')) {
          return value
        }
        return undefined
      },
      creating: {},
    },
    maxReconnect: {
      default: 3,
      label: 'Reconnect count',
      max: 99,
      min: 0,
      path: 'options.gelfTcpMaxReconnect',
      required: false,
      validate(value) {
        if (value && value > 99) {
          return 'Maximum is 99'
        }
        return null
      },
      prepare(value, entity) {
        if (entity.options.gelfAddress.includes('tcp://')) {
          return value
        }
        return undefined
      },
      creating: {},
    },
    reconnectDelay: {
      default: 1,
      label: 'Reconnect delay',
      max: 10,
      min: 0,
      path: 'options.gelfTcpReconnectDelay',
      required: false,
      validate(value) {
        if (value && value > 10) {
          return 'Maximum is 10'
        }
        return null
      },
      prepare(value, entity) {
        if (entity.options.gelfAddress.includes('tcp://')) {
          return value
        }
        return undefined
      },
      creating: {},
    },
    labels: {
      default: '',
      label: 'Labels',
      path: 'options.labels',
      required: false,
      validate() {
        return null
      },
      creating: {},
    },
    regex: {
      default: '',
      label: 'Env Regex',
      path: 'options.envRegex',
      required: false,
      validate() {
        return null
      },
      creating: {},
    },
  }
}

export default D2C_ProviderGelf
